import { useState, FC } from 'react';
import { FunctionField, useListContext, useNotify } from 'react-admin';
import { Button } from '@material-ui/core';
import { CsvReportDownloadModal } from './CsvReportDownloadModal';
import { downloadCsvReport } from './download';
import { useDispatch } from 'react-redux';

export const CsvReportOpenButton: FC = () => {
  useListContext();
  const [open, setOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const notify = useNotify();
  const dispatch = useDispatch();

  const handleOpen = (record: any) => {
    setSelectedReport(record);
    setOpen(true);
  };

  const handleModalSubmit = async ({ dateFrom, dateTo }: { dateFrom: string; dateTo: string }) => {
    try {
      setLoading(true);
      await downloadCsvReport({ id: selectedReport.id, dateFrom, dateTo, title: selectedReport.title, dispatch });
      setOpen(false);
    } catch (e: any) {
      notify(e?.message || 'Download failed', 'warning');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <FunctionField
        label="Open"
        render={(record: any) => (
          <Button
            color="primary"
            variant="contained"
            onClick={() => handleOpen(record)}
          >
            Open
          </Button>
        )}
      />
      <CsvReportDownloadModal
        loading={loading}
        open={open}
        report={selectedReport}
        onClose={() => setOpen(false)}
        onSubmit={handleModalSubmit}
      />
    </>
  );
};
